import { render } from "./BasePagination.vue?vue&type=template&id=cc206ab6"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"
script.render = render

export default script